import {Sort} from "../models/sort";

export class SortHelper {
  static convertSortToString(sort: Sort): string {
    return `${sort.field},${sort.direction}`;
  }

  static convertStringToSort(sort: string): Sort {
      const [field, direction] = sort.split(',');
      return {field, direction: direction as 'asc' | 'desc' ?? 'asc'};
  }
}
